export const LOGIN = 'Favorite/Auth/LOGIN';

export const LOGOUT = 'Favorite/Auth/LOGOUT';

export const CLOCKIN = 'Favorite/Auth/CLOCKIN';

export const CLOCKOUT = 'Favorite/Auth/CLOCKOUT';

export const UNAUTHORIZED = 'Favorite/Auth/UNAUTHORIZED';
